(function(app, $) {
    var $cache = {};
    // sub namespace app.util.* contains utility functions
    app.util = {

        "addLoader" : function(elem, position) {
            if(!elem || $(elem).length === 0) {
                return;
            }

            elem = $(elem);
            var $loader = $('<img />').attr('src', app.urls.ajaxloader).attr('class', 'ajax-loader');

            switch(position) {
                case "before":
                    elem.before($loader);
                    break;
                case "prepend":
                    elem.prepend($loader);
                    break;
                case "append":
                    elem.append($loader);
                    break;
                case "after":
                default:
                    elem.after($loader);
                    break;
            }
        },

        "removeLoader" : function(elem) {
            if(!elem || $(elem).length === 0) {
                return;
            }

            $(elem).find('img.ajax-loader').remove();
            $(elem).siblings('img.ajax-loader').remove();
        },

        /**
         * Trims a prefix from a given string, this can be used to trim a certain prefix from DOM element IDs for further processing on the ID
         */
        "trimPrefix" : function(str, prefix) {
            return str.substring(prefix.length);
        },

        /**
         * @todo  Add description
         */
        "padLeft" : function(str, padChar, len) {
            var digs = len || 10;
            var s = str.toString();
            var dif = digs - s.length;

            while(dif > 0) {
                s = padChar + s;
                dif--;
            }

            return s;
        },

        /**
         * Appends the parameter with the given name and value to the given url and returns the changed url
         *
         * @todo Add checking for hash tag in url
         */
        "appendParamToURL" : function(url, name, value) {
            if(!url) {
                return null;
            }
            var c = "?";

            if(url.indexOf(c) !== -1) {
                c = "&";
            }

            return url + c + name + "=" + encodeURIComponent(value);
        },

        /**
         * @todo  Add description
         */
        "appendParamsToUrl" : function(url, params, includeHash) {
            var uri = app.util.getUri(url);
            includeHash = includeHash || false;

            var qsParams = $.extend(uri.queryParams, params);
            var result = (uri.protocol ? uri.protocol : '') +
                (uri.hostname ? "//" + uri.hostname : '') +
                (uri.path ? (uri.path.charAt(0) !== "/" ? "/" : '') + uri.path : '') +
                "?" + $.param(qsParams);

            if(includeHash) {
                result += uri.hash;
            }

            if(result.indexOf("http") < 0 && result.charAt(0) !== "/") {
                result = "/" + result;
            }

            return result;
        },

        /**
         * @todo  Add description
         */
        "removeParamFromURL" : function(url, parameter) {
            if(!url) {
                return;
            }
            var urlparts = url.split('?');

            if(urlparts.length >= 2) {
                var urlBase = urlparts.shift();
                var queryString = urlparts.join("?");

                var prefix = encodeURIComponent(parameter) + '=';
                var pars = queryString.split(/[&;]/g);
                var i = pars.length;

                while(0 < i--) {
                    if(pars[ i ].lastIndexOf(prefix, 0) !== -1) {
                        pars.splice(i, 1);
                    }
                }
                url = pars.length ? (urlBase + '?' + pars.join('&')) : urlBase;
            }

            return url;
        },

        /**
         * @todo  Add description
         */
        "ajaxUrl" : function(path) {
            return app.util.appendParamToURL(path, "format", "ajax");
        },

        /**
         * @todo  Add description
         */
        "toAbsoluteUrl" : function(url) {
            if(url && url.indexOf("http") !== 0 && url.charAt(0) !== "/") {
                url = "/" + url;
            }

            return url;
        },

        /**
         * @todo  Add description
         */
        "toRelativeURL" : function(url) {
            if(url.indexOf("http") === 0 || url.charAt(0) !== "/") {
                return url.replace(/^(?:\/\/|[^\/]+)*/, "");
            }

            return url;
        },

        /**
         * Uses the String::replace method to iterate over each name-value pair in the string
         *
         * @param  {String} qs Query string
         * @return {Object} key: value object with url parameters
         */
        "getQueryStringParams" : function(qs) {
            if(!qs || qs.length === 0) {
                return {};
            }

            var params = {};

            qs.replace(new RegExp("([^?=&]+)(=([^&]*))?", "g"),
                function($0, $1, $2, $3) {
                    try {
                        params[ decodeURIComponent($1) ] = decodeURIComponent($3);
                    } catch(e) {
                        console.log(e);
                    }
                }
           );

            return params;
        },

        /**
         * @todo  Add description
         */
        "getParameterValueFromUrl" : function(parameterName, url) {
            var currentQueryString = url || window.location.search;
            var currentQueryStringParams = this.getQueryStringParams(currentQueryString);

            return currentQueryStringParams[ parameterName ];
        },

        /**
         * @todo  Add description
         */
        "getUri" : function(o) {
            var a;

            if(o.tagName && $(o).attr("href")) {
                a = o;
            } else if(typeof o === "string") {
                a = document.createElement("a");
                a.href = o;
            } else {
                return null;
            }

            // overcome some stupid ie behaviour
            if(a.host === "") {
                a.href = a.href;
            }

            // all actual version of IE not so smart to correctly process
            // protocol independent locations, so wee need to help them
            if(a.protocol === ':') {
                a.protocol = window.location.protocol;
            }

            // fix for some IE browsers
            if(a.pathname.indexOf("/") != 0) {
                a.pathname = "/" + a.pathname;
            }

            return {
                "protocol"     : a.protocol, //http:
                "host"         : a.host, //www.myexample.com
                "hostname"     : a.hostname, //www.myexample.com'
                "port"         : a.port, //:80
                "path"         : a.pathname, // /sub1/sub2
                "query"        : a.search, // ?param1=val1&param2=val2
                "queryParams"  : a.search.length > 1 ? app.util.getQueryStringParams(a.search.substr(1)) : {},
                "hash"         : a.hash, // #OU812,5150
                "url"          : a.protocol + "//" + a.host + a.pathname,
                "urlWithQuery" : a.protocol + "//" + a.host + a.port + a.pathname + a.search
            };
        },

        /**
         * Method to check if current element is empty
         *
         * @param {string|array|object|number} arg Argument to check
         * @return {Boolean}
         */
        "empty" : function(arg) {
            var argType = typeof arg;

            if(arg == null) {
                return true;
            }

            if(/(string|array|object|number)/.test(argType) && arg.length > 0) {
                return false;
            }

            return true;
        },

        /**
         * @todo  Add description
         */
        "postForm" : function(args) {
            var form = $("<form>").attr({
                "action" : args.url,
                "method" : "post"
            }).appendTo("body");
            var p;

            for(p in args.fields) {
                $("<input>").attr({
                    "name"  : p,
                    "value" : args.fields[ p ]
                }).appendTo(form);
            }
            form.submit();
        },

        /**
         * @todo  Add description
         */
        "scrollBrowser" : function(xLocation, scrollUpTiming, callback) {
            $('html, body').animate({
                "scrollTop" : xLocation
            }, scrollUpTiming).promise().done(callback);
        },

        /**
         * @todo  Add description
         */
        "getCookie" : function(cookiename) {
            var cookiestring = RegExp(String(cookiename + "[^;]+")).exec(document.cookie);

            return unescape(Boolean(cookiestring) ? cookiestring.toString().replace(/^[^=]+./, "") : "");
        },

        /**
         * @todo  Add description
         */
        "setCookie" : function(name, value, options) {
            options = options || {};

            var expires = options.expires;

            if(typeof expires == "number" && expires) {
                var d = new Date();

                d.setTime(d.getTime() + expires * 1000);
                expires = options.expires = d;
            }

            if(expires && expires.toUTCString) {
                options.expires = expires.toUTCString();
            }

            value = encodeURIComponent(value);

            var updatedCookie = name + "=" + value;

            for(var propName in options) {
                updatedCookie += "; " + propName;
                var propValue = options[ propName ];

                if(propValue !== true) {
                    updatedCookie += "=" + propValue;
                }
            }

            document.cookie = updatedCookie;
        },

        /**
         * @todo  Add description
         */
        "deleteCookie" : function(cookiename) {
            document.cookie = cookiename + "=;path=/;expires=Thu, 01-Jan-70 00:00:01 GMT;";
        },

        /**
         * Method to check is the element in current viewport
         *
         * @description Initial solution recommended by John Resig
         * @see http://ejohn.org/blog/getboundingclientrect-is-awesome/
         * @see http://stackoverflow.com/a/12418814
         * @param {DOMNode} element DOM Node to check
         * @return {Boolean}
         */
        "isElementInViewport" : function(element) {
            var rect = element.getBoundingClientRect();

            return (
                rect.bottom >= 0 &&
                rect.right >= 0 &&
                rect.top <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
                rect.left <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
           );
        },

        /**
         * Handles delayed event handler fire
         *
         * @see http://remysharp.com/2010/07/21/throttling-function-calls/
         * @param {Function} callback Callback function to call
         * @param {Number} threshhold Delay before callback fire
         * @param {Object} scope The context to for callback fire
         * @return {Function}
         */
        "eventDelay" : function(callback, threshhold, scope, skipInitialCall) {
            threshhold || (threshhold = 250);
            var last,
                deferTimer;

            /**
             * @todo  Add description
             */
            return function() {
                var context = scope || this,
                    now = (new Date()).getTime(),
                    args = arguments;

                if(last && now < last + threshhold) {
                    clearTimeout(deferTimer);
                    deferTimer = setTimeout(function() {
                        last = now;
                        callback.apply(context, args);
                    }, threshhold);
                } else {
                    last = now;

                    if(!skipInitialCall) {
                        callback.apply(context, args);
                    }
                }
            };
        },

        /**
         * Throttling Function Calls
         *
         * @see http://www.nczonline.net/blog/2007/11/30/the-throttle-function/
         * @param {Function} callback Callback function to call
         * @param {Number} delay Delay before callback fire
         * @param {Object} scope The context to for callback fire
         */
        "throttle" : function(callback, delay, scope) {
            clearTimeout(callback._tId);
            callback._tId = setTimeout(function() {
                callback.call(scope);
            }, delay || 100);
        },

        /**
         * Calculation of the object properties size
         *
         * @see http://stackoverflow.com/a/6700/11236
         * @param {Object} object Object with properties to calculate
         */
        "objectSize" : function(object) {
            var size = 0;

            for(var key in object) {
                if(object.hasOwnProperty(key)) {
                    size++;
                }
            }

            return size;
        },

        /**
         * @todo  Add description
         */
        "removeHTMLEntities" : function(str) {
            if(!str) {
                return '';
            }

            return str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
        },

        /**
         * Create mutation observer for widget placement and start observe modification of its DOM sub-tree
         *
         * @param {Object} $target jQuery DOM object
         * @param {Object} observeOptions The set of DOM node properties to observe
         * @param {Function} callback The callback to fire on mutation observed
         * @param {Number} delay The delay between firing of the callback
         * @return {Object} MuntationOserver
         */
        "observeDOMModification" : function($target, observeOptions, callback, delay) {
            if(!$target.length || !app.util.objectSize(observeOptions) || 'function' !== typeof callback) {
                return;
            }

            var observer = new MutationObserver(app.util.eventDelay(function(mutations) {
                callback.call($target, mutations);
            }, delay || 500));

            observer.observe($target.get(0), observeOptions);

            return observer;
        },

        /**
         * Getting the array of values from specified object
         *
         * @todo Better to use it as fallback for Object.values(...)
         * @param {Object} object
         * @return {Array}
         */
        "getObjectValues"     : function(object) {
            var result = [];
            var source = object || {};

            for(var key in source) {
                if(source.hasOwnProperty(key)) {
                    result.push(source[ key ]);
                }
            }

            return result;
        },
        /**
         * Get Object of submitted values from the reqeust
         * If more than one value is submitted with the same parameter name returned object will contain array of values
         *
         * @return {Object}
         */
        "getArrayQueryString" : function() {
            var query_string = {};
            var query = window.location.search.substring(1);
            var vars = query.split("&");

            for(var i = 0 ; i < vars.length ; i++) {
                var pair = vars[ i ].split("=");

                // If first entry with this name
                if(typeof query_string[ pair[ 0 ] ] === "undefined") {
                    query_string[ pair[ 0 ] ] = decodeURIComponent(pair[ 1 ]);
                    // If second entry with this name
                } else if(typeof query_string[ pair[ 0 ] ] === "string") {
                    var arr = [ query_string[ pair[ 0 ] ], decodeURIComponent(pair[ 1 ]) ];

                    query_string[ pair[ 0 ] ] = arr;
                    // If third or later entry with this name
                } else {
                    query_string[ pair[ 0 ] ].push(decodeURIComponent(pair[ 1 ]));
                }
            }

            return query_string;
        },

        'replaceAll' : function(find, replace) {
            var str = this;
            return str.replace(new RegExp(find.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g'), replace);
        },

        'slug' : function(str) {
            if(!arguments.callee.re)
                arguments.callee.re = [ /[^a-z0-9]+/ig, /^-+|-+$/g ];

            return str.toLowerCase().replace(arguments.callee.re[ 0 ], '-').replace(arguments.callee.re[ 1 ], '');
        },

        'removeDiacritics' : function(s) {
            var diacritics = [
                [ /[\300-\306]/g, 'A' ],
                [ /[\340-\346]/g, 'a' ],
                [ /[\310-\313]/g, 'E' ],
                [ /[\350-\353]/g, 'e' ],
                [ /[\314-\317]/g, 'I' ],
                [ /[\354-\357]/g, 'i' ],
                [ /[\322-\330]/g, 'O' ],
                [ /[\362-\370]/g, 'o' ],
                [ /[\331-\334]/g, 'U' ],
                [ /[\371-\374]/g, 'u' ],
                [ /[\321]/g, 'N' ],
                [ /[\361]/g, 'n' ],
                [ /[\307]/g, 'C' ],
                [ /[\347]/g, 'c' ],
            ];

            for(var i = 0 ; i < diacritics.length ; i++) {
                s = s.replace(diacritics[ i ][ 0 ], diacritics[ i ][ 1 ]);
            }
            return s;
        }

    };

    /*
     *  Double tap event
     *  Developer : Anton Serdiuk (a.serdiuk@astoundcommerce.com)
     *  Date : 8.7.2014
     *  Usage : $(selector).on('doubletap',function(){});
     *
     */
    $.event.special.doubletap = {
        "bindType"     : 'touchend',
        "delegateType" : 'touchend',

        /**
         * @todo  Add description
         */
        "handle" : function(event) {
            var handleObj = event.handleObj,
                touchList = event.changedTouches,
                targetData = jQuery.data(event.target),
                now = Date.now(),
                delta = targetData.lastTouch ? now - targetData.lastTouch : 0,
                delay = delay == null ? 300 : delay,
                dist = 15,
                closeX = targetData.screenX && (targetData.screenX + dist) > touchList[ 0 ].screenX && (targetData.screenX - dist) < touchList[ 0 ].screenX,
                closeY = targetData.screenY && (targetData.screenY + dist) > touchList[ 0 ].screenY && (targetData.screenY - dist) < touchList[ 0 ].screenY;

            if(delta < delay && delta > 30 && closeX && closeY) {
                targetData.lastTouch = null;
                targetData.screenX = null;
                targetData.screenY = null;
                handleObj.handler.apply(this, arguments);

            } else {
                targetData.lastTouch = now;
                targetData.screenX = touchList[ 0 ].screenX;
                targetData.screenY = touchList[ 0 ].screenY;
            }
        }
    };
}(window.app = window.app || {}, jQuery));
